module.exports = __webpack_public_path__ + "static/media/Grassi-Ribolla-Gialla.b8068582.png";